import { PayloadAction, createSlice } from "@reduxjs/toolkit";

import { IKeyData } from "infrastructure";
import { INotification } from "infrastructure/notification";
import { actionProcessing } from "infrastructure/store";

import { IAccount, getInitialAccountsState, IAccountsState } from "./Account.state";

const initialState = getInitialAccountsState();

export const accounts = createSlice({
  name: "accounts",
  initialState: initialState,
  reducers: {
    loadAccounts: (state, action: PayloadAction<IKeyData>) => {
      return {
        ...state,
        [action.payload.id]: { ...state[action.payload.id], isLoading: true, notification: undefined }
      };
    },
    loadAccountsCompleted: (state, action: PayloadAction<IKeyData<IAccount[]>>) => {
      return {
        ...state,
        [action.payload.id]: { ...state[action.payload.id], isLoading: false, items: action.payload.data }
      };
    },
    loadAccountsFailed: (state, action: PayloadAction<IKeyData<INotification>>) => {
      return {
        ...state,
        [action.payload.id]: { ...state[action.payload.id], isLoading: false, notification: action.payload.data }
      };
    },
    reset: actionProcessing.createWithClearNotification((state: IAccountsState, action: PayloadAction<IKeyData>) => {
      const { [action.payload.id]: _, ...rest } = state;

      return {
        ...rest
      };
    }),
    clearAccounts: (state, action: PayloadAction<IKeyData>) => {
      return {
        ...state,
        [action.payload.id]: { ...state[action.payload.id], isLoading: false, items: [] }
      };
    }
  }
});
